import { Navigate } from '@tanstack/react-router'
import { useAdminRuntimeCapabilities } from '@features/admin/api/admin.api'
import { AdminRecuperaScreen } from '@features/admin/ui/AdminRecuperaScreen'

export function RecuperaPage() {
  const capabilities = useAdminRuntimeCapabilities()

  if (capabilities.isPending) {
    return null
  }

  if (capabilities.data?.recuperaAiEnabled !== true) {
    return <Navigate to="/" replace />
  }

  return <AdminRecuperaScreen />
}
